<template lang="pug">
  div(v-if="currentTemplate")
    t-key-value-data(
      v-for="(row, idx) in rows"
      :key="idx"
      :item="row"
    )
</template>

<script>
import { mapGetters } from 'vuex'
import TKeyValueData from '~/components/templates/t-key-value-data'

export default {
  name: 'BlockTemplateGeneralInfo',
  components: {
    TKeyValueData
  },
  props: {
    templateId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('admintemplates', {
      items: 'items'
    }),
    currentTemplate() {
      return this._.find(this.items, item => item.id === this.documentId)
    },
    rows() {
      return [
        {
          key: this.$t('Name'),
          value: this.currentTemplate.title
        }
      ]
    }
  },
  created() {
    this.fetchTemplate()
  },
  methods: {
    async fetchTemplate() {
      try {
        await this.$store.dispatch('admintemplates/read', { id: this.templateId })
      } catch (e) {
        this.$handlers.error(e, this)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
